"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesTableHeaderContainer = void 0;
var _reactRedux = require("react-redux");
var _futuresPositionsActions = require("../../../redux/futures/actions/futuresPositionsActions");
var _FuturesBalancesTableHeader = require("./FuturesBalancesTableHeader");
var _reduxForm = require("redux-form");
var _futuresSelectors = require("../../../redux/futures/selectors/futuresSelectors");
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getFuturesPositionHistory: function getFuturesPositionHistory(accountId, OMSId, startDate, endDate) {
      return dispatch((0, _futuresPositionsActions.getFuturesPositionHistory)(accountId, OMSId, startDate, endDate));
    }
  };
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: (0, _futuresSelectors.futuresAccountIdSelector)(state),
    OMSId: state.user.userInfo.OMSId
  };
};
var FuturesBalancesTableHeaderContainer = exports.FuturesBalancesTableHeaderContainer = (0, _reduxForm.reduxForm)({
  form: 'futuresBalancesTableHeader',
  destroyOnUnmount: false
})((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FuturesBalancesTableHeader.FuturesBalancesTableHeader));